export default "__VITE_ASSET__BCMIjHkd__"